import React from "react";
import { Container, Card, Alert } from "react-bootstrap";
import { API_BASE_URL } from "../config";

export default function PrivacyPolicy() {
  const effectiveDate = "18/12/2025";

  return (
    <main className="py-5">
      <Container style={{ maxWidth: 900 }}>
        <h1 className="mb-3">Privacy Policy</h1>
        <p className="text-muted">Ultimo aggiornamento: {effectiveDate}</p>

        <Alert variant="secondary" className="mb-4">
          Questa informativa descrive come vengono trattati i dati personali su
          lylescoaching.com (servizi di coaching, account, acquisto workout, contatti).
        </Alert>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">1) Titolare del trattamento</h2>
            <p className="mb-0">
              <strong>Titolare:</strong> Lyle’s Coaching (il “Titolare”).<br />
              <strong>Contatti:</strong> usa il form “Contact” sul sito oppure l’email
              indicata nella sezione contatti del sito.
            </p>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">2) Dati che raccogliamo</h2>
            <ul className="mb-0">
              <li><strong>Dati account</strong>: nome, cognome, username, email, password (salvata cifrata/hashed).</li>
              <li><strong>Dati profilo</strong>: città/stato (se inseriti).</li>
              <li><strong>Dati coaching</strong>: informazioni inserite nei form (obiettivi, misure, preferenze, messaggi).</li>
              <li><strong>Dati di contatto</strong>: messaggi inviati dal form contatti.</li>
              <li><strong>Dati di acquisto</strong>: identificativi transazione e stato pagamento tramite Stripe (non memorizziamo i dati della carta).</li>
              <li><strong>Dati tecnici</strong>: IP e log tecnici minimi per sicurezza/diagnostica (a livello server/hosting).</li>
            </ul>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">3) Finalità e base giuridica</h2>
            <ul className="mb-0">
              <li><strong>Creazione e gestione account</strong> (esecuzione contratto/servizio).</li>
              <li><strong>Autenticazione e sicurezza</strong> (legittimo interesse / sicurezza del servizio).</li>
              <li><strong>Erogazione coaching</strong> e gestione richieste (esecuzione servizio).</li>
              <li><strong>Pagamenti e fatturazione</strong> (esecuzione contratto + obblighi legali).</li>
              <li><strong>Assistenza e comunicazioni operative</strong> (esecuzione servizio / legittimo interesse).</li>
            </ul>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">4) Conservazione</h2>
            <ul className="mb-0">
              <li><strong>Account</strong>: finché l’account resta attivo.</li>
              <li><strong>Richieste coaching/contatto</strong>: per il tempo necessario a gestire la richiesta e per eventuali obblighi.</li>
              <li><strong>Dati transazione</strong>: secondo obblighi fiscali/contabili o necessità di contestazioni.</li>
            </ul>
            <p className="text-muted mt-2 mb-0">
              Nota: i tempi precisi possono dipendere da obblighi di legge o tutela in caso di dispute.
            </p>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">5) Condivisione con terze parti</h2>
            <p>Condividiamo dati solo quando serve per erogare il servizio:</p>
            <ul className="mb-0">
              <li><strong>Hosting/Database/Backend</strong>: infrastruttura (es. Railway / provider cloud).</li>
              <li><strong>Pagamento</strong>: Stripe per gestire checkout e transazioni.</li>
              <li><strong>Email</strong>: provider SMTP per invio email operative/contatto.</li>
            </ul>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">6) Trasferimenti extra-UE</h2>
            <p className="mb-0">
              Alcuni fornitori (es. pagamenti/hosting/email) possono trattare dati fuori dall’UE.
              In tali casi si fa riferimento a meccanismi di garanzia previsti dal GDPR (es. clausole contrattuali standard),
              secondo quanto previsto dai rispettivi fornitori.
            </p>
          </Card.Body>
        </Card>

        <Card className="mb-4">
          <Card.Body>
            <h2 className="h5">7) Diritti dell’utente</h2>
            <p>Puoi richiedere: accesso, rettifica, cancellazione, limitazione, portabilità, opposizione.</p>
            <p className="mb-0">
              Per esercitare i diritti: contatta il Titolare tramite i recapiti del sito.
              Hai anche diritto di reclamo al Garante per la Protezione dei Dati Personali.
            </p>
          </Card.Body>
        </Card>

        <Card>
          <Card.Body>
            <h2 className="h5">8) Info tecniche utili</h2>
            <p className="mb-0">
              Il sito usa un backend API (attualmente configurato su: <code>{API_BASE_URL}</code>).
              L’autenticazione avviene tramite cookie di sessione (vedi Cookie Policy).
            </p>
          </Card.Body>
        </Card>
      </Container>
    </main>
  );
}
